// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Pin_Filled_Corner0_Rounded = createSinglePathSVG({
  path: 'm22.062 9.75-5.013 5.03c.428 1.188.605 3.177-1.236 5.625a1.5 1.5 0 0 1-1.094.595h-.106a1.5 1.5 0 0 1-1.061-.44l-4.525-4.529-3.996 4a.75.75 0 0 1-1.062-1.062l4-3.996-4.528-4.528a1.5 1.5 0 0 1 .122-2.23C5.946 6.292 8.227 6.67 9.224 6.983l5.025-5.042a1.5 1.5 0 0 1 2.122 0l5.69 5.688a1.5 1.5 0 0 1 0 2.121Z',
  viewBox: '0 0 24 24',
  glyph: 'Pin_Filled_Corner0_Rounded',
})

export const Pin_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'm22.061 7.628-5.69-5.688a1.5 1.5 0 0 0-2.121 0L9.222 6.983c-1-.313-3.281-.69-5.662 1.232a1.5 1.5 0 0 0-.121 2.23l4.53 4.528-4 3.996a.75.75 0 0 0 1.062 1.062l3.996-4 4.527 4.527a1.5 1.5 0 0 0 1.062.442h.106a1.5 1.5 0 0 0 1.09-.593c1.842-2.447 1.665-4.437 1.237-5.625l5.013-5.032a1.5 1.5 0 0 0 0-2.122ZM21 8.69h0l-5.37 5.387a.75.75 0 0 0-.139.864c.887 1.775-.169 3.618-.875 4.558L4.5 9.383c1.133-.914 2.216-1.155 3.045-1.155a3.8 3.8 0 0 1 1.53.303.75.75 0 0 0 .868-.141L15.311 3 21 8.689Z',
  viewBox: '0 0 24 24',
  glyph: 'Pin_Stroke2_Corner0_Rounded',
})

export const PinLocation_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M12 6a3.75 3.75 0 1 0 3.75 3.75A3.75 3.75 0 0 0 12 6Zm0 6a2.25 2.25 0 1 1 2.25-2.25A2.25 2.25 0 0 1 12 12Zm0-10.5a8.26 8.26 0 0 0-8.25 8.25c0 2.944 1.36 6.064 3.938 9.023a23.8 23.8 0 0 0 3.885 3.591.75.75 0 0 0 .861 0 23.8 23.8 0 0 0 3.879-3.59c2.573-2.96 3.937-6.08 3.937-9.024A8.26 8.26 0 0 0 12 1.5Zm0 19.313c-1.55-1.22-6.75-5.696-6.75-11.063a6.75 6.75 0 0 1 13.5 0c0 5.365-5.2 9.844-6.75 11.063Z',
  viewBox: '0 0 24 24',
  glyph: 'PinLocation_Stroke2_Corner0_Rounded',
})

export const PinLocationFilled_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M12 1.5a8.26 8.26 0 0 0-8.25 8.25c0 7.06 7.5 12.39 7.82 12.614a.75.75 0 0 0 .86 0c.32-.223 7.82-5.555 7.82-12.614A8.26 8.26 0 0 0 12 1.5Zm0 5.25a3 3 0 1 1-3 3 3 3 0 0 1 3-3Z',
  viewBox: '0 0 24 24',
  glyph: 'PinLocationFilled_Stroke2_Corner0_Rounded',
})
